import React, { Component } from "react";
import {
  Table,
  Input,
  DatePicker,
  Select,
  Descriptions,
  Badge,
  Spin,
  Tabs,
} from "antd";
import { isEmpty } from "lodash";
import consts from "../consts";
import utils from "../common/utils";
import moment from "moment";
import styled from "styled-components";
import Modal from "antd/lib/modal/Modal";
import DisplayControl from "./DisplayControl";

const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

const DetailHover = styled.div`
  &:hover {
    color: #40a9ff;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Center = styled.div`
  text-align: center;
`;
const { RangePicker } = DatePicker;

class TransactionError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      historyCount: 0,
      isLoading: false,
      currentPage: 1,
      historyPage:1,
      txHash: "",
      loading: true,
      visible: false,
    };
    this.filter = {
      coin: "ETH",
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
      start: 0,
      end: new Date().getTime(),
    };
    this.acceptParams = {};
  }

  columns = [
    {
      align: "center",
      title: "Tx Hash",
      dataIndex: "hash",
      key: "hash",
      render: (hash) => <div title={hash}>{hash}</div>,
    },
    {
      align: "center",
      title: "Thời gian giao dịch",
      dataIndex: "created_at",
      key: "created_at",
      render: (timeStamp) =>
        utils.formatTimeFromUnix(timeStamp, "DD/MM/YYYY HH:mm"),
    },
    {
      align: "center",
      title: "Blockchain",
      dataIndex: "chain",
      key: "chain",
    },
    {
      align: "center",
      title: "Chi tiết",
      dataIndex: "delete",
      key: "delete",
      width: 100,
      render: (text, record) => (
        <DisplayControl
          permission_link_screen={[
            {
              permission: consts.AUTH.TRANSACTION__VERIFY,
              action: consts.CONTROLS.POST,
            },
            {
              permission: consts.AUTH.TRANSACTION__ACCEPT,
              action: consts.CONTROLS.POST,
            },
          ]}
        >
          <DetailHover
            onClick={() => {
              this.setState({ visible: true, loading: true });
              this.props.verifyTransaction(
                { txhash: record.hash, chain: record.chain },
                () => {
                  this.acceptParams = {
                    txhash: record.hash,
                    chain: record.chain,
                  };
                  this.setState({ loading: false });
                }
              );
            }}
          >
            Chi tiết
          </DetailHover>
        </DisplayControl>
      ),
    },
  ];

  historyColumns = [
    {
      align: "center",
      title: "Thời gian",
      dataIndex: "verified_at",
      key: "verified_at",
      render: (text) =>
      utils.formatTimeFromUnix(text, "DD/MM/YYYY HH:mm"),
    },
    {
      align: "center",
      title: "Tx Hash",
      dataIndex: "txhash",
      key: "txhash",
      ellipsis: true,
    },
    {
      align: "right",
      title: "Số lượng",
      dataIndex: "amount",
      key: "amount",
      render: (text,record) => (
        <>{text} {record.coin}</>
      )
    },
    {
      align: "center",
      title: "Địa chỉ nhận",
      dataIndex: "address",
      ellipsis: true,
      key: "address",
    },
    {
      align: "center",
      title: "Bởi",
      ellipsis: true,
      dataIndex: "verified_by",
      key: "verified_by",
    },
  ];

  componentDidMount() {
    this.fetchData();
    this.fetchHistory();

  }

  fetchHistory = (params = {}) => {
      this.props.onFetchVerifyHistory(params,(size)=> {this.setState({historyCount:size})})
  }

  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
    this.setState({ isLoading: true });
    this.filter = {
      ...this.filter,
      pos,
      count,
    };
    this.props.onFetchTransErrorAction(this.filter, this.updateTotalCount);
  };

  fetchDataWithTime = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
    this.setState({ isLoading: true });
    this.filter = {
      ...this.filter,
      pos,
      count,
    };
    this.props.onFetchTransErrorFilterAction(
      this.filter,
      this.updateTotalCount
    );
  };

  updateTotalCount = (totalCount) => {
    this.setState({
      totalCount,
      isLoading: false,
    });
  };

  searchTxHash = (value) => {
    if (value !== "") {
      this.props.onSearchTransErrorAction(
        {
          coin: "ETH",
          txhash: value,
        },
        this.updateTotalCount
      );
    }
  };

  onClearSearch = () => {
    this.fetchData({ ...this.filter });
  };

  onChangeDate = (value) => {
    if (value !== null) {
      var [startTime, endTime] = value;
      this.filter.start = startTime.startOf("day").unix();
      this.filter.end = endTime.endOf("day").unix();
      this.setState({ currentPage: 1 });
      this.fetchDataWithTime();
    } else {
      this.filter.start = "";
      this.filter.end = "";
      this.setState({ currentPage: 1 });
      this.fetchData();
    }
  };

  onCancelModal = () => {
    this.setState({ visible: false });
  };

  onOkModal = () => {
    this.props.acceptTransaction(
      {
        ...this.acceptParams,
        coin: this.acceptParams.chain,
      },
      () => {
        this.fetchData({ ...this.filter });
        this.setState({ visible: false });
      }
    );
  };

  deleteTransaction = () => {
    this.props.deleteTransaction(
      { ...this.acceptParams, coin: this.acceptParams.chain },
      this.fetchData
    );
  };

  handleSelectChainChange = (value) => {
    this.filter = {
      ...this.filter,
      coin: value,
    };
    this.fetchData();
  };
  render() {
    const { txErrors } = this.props;
    const { created_at, address, amount, coin } = this.props.verifyInfo || {};
    return (
      <div className="withdrawalHistory">
        <h2> Danh sách giao dịch lỗi chưa xử lý </h2>
        <Tabs>
          <TabPane tab="Danh sách giao dịch lỗi" key="1">
            <div className="transaction d-flex align-items space-between">
              <div>
                <span style={{ marginRight: 8 }}>
                  {" "}
                  Thời gian phát hiện lỗi:
                </span>
                <RangePicker
                  locale={consts.LangDateVi}
                  disabledDate={(current) =>
                    current && current > moment().endOf("day")
                  }
                  onChange={this.onChangeDate}
                />
              </div>
              <div>
                <span>Chuỗi giao dịch bị lỗi:</span>
                <Select
                  style={{ width: "200px", marginLeft: "10px" }}
                  defaultValue={"ETH"}
                  onChange={this.handleSelectChainChange}
                >
                  <Option value="ETH">ETH</Option>
                  <Option value="TOMO">TOMO</Option>
                </Select>
              </div>
              <Search
                placeholder={"Search Txn Hash"}
                enterButton
                onSearch={this.searchTxHash}
                onChange={this.onClearSearch}
                enterButton="Tìm kiếm"
                style={{ width: 500 }}
                allowClear
              />
            </div>
            <Table
              columns={this.columns}
              dataSource={txErrors || []}
              pagination={{
                defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                current: this.state.currentPage,
                showSizeChanger: false,
                total: this.state.totalCount,
                onChange: (page, pageSize) => {
                  {
                    this.filter.end && this.filter.start
                      ? this.fetchDataWithTime((page - 1) * pageSize, pageSize)
                      : this.fetchData((page - 1) * pageSize, pageSize);
                  }
                  this.setState({
                    currentPage: page,
                    isLoading: true,
                  });
                },
                hideOnSinglePage: true,
                responsive: true,
              }}
              bordered
              loading={this.state.isLoading}
            />

            <Modal
              title="Chi tiết giao dịch"
              visible={this.state.visible}
              onCancel={this.onCancelModal}
              onOk={this.onOkModal}
              okText="Xác nhận giao dịch"
              cancelText="Hủy"
            >
              {this.state.loading ? (
                <Center>
                  <Spin />
                </Center>
              ) : (
                !isEmpty(this.props.verifyInfo) && (
                  <Descriptions
                    title={
                      <Badge status="processing" text="Thông tin giao dịch" />
                    }
                  >
                    <Descriptions.Item label="Địa chỉ nhận" span={3}>
                      {address}
                    </Descriptions.Item>
                    <Descriptions.Item label="Số lượng giao dịch" span={3}>
                      {amount} {coin}
                    </Descriptions.Item>
                    <Descriptions.Item span={3} label="Thời gian giao dịch">
                      {utils.formatTimeFromUnix(
                        created_at,
                        "DD/MM/YY HH:mm:ss"
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                )
              )}
            </Modal>
          </TabPane>
          <TabPane tab="Các giao dịch lỗi đã xác nhận" key="2">
            <Table columns={this.historyColumns} dataSource={this.props.verifyHistories}
              pagination={{
                defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                current: this.state.historyPage,
                showSizeChanger: false,
                total: this.state.historyCount,
                onChange:(page, pageSize) => {
                  this.props.onFetchVerifyHistory({pos: pageSize*(page-1), count: pageSize},(size)=> {this.setState({historyCount:size})})
                }
              }}
            ></Table>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default TransactionError;
